// Third-party
import { environment } from '@environment';

/**
 * Builds a Classic File & ServeXpress URL that establishes the legacy session via
 * `Login/Login.aspx?oauth=true` and then redirects to the requested page through the legacy
 * `returnURL` support. All Classic navigation must go through this URL so the legacy session is
 * established (Login -> WebServer/Default.asp -> Home.aspx redirects to returnURL).
 *
 * This is the single source of the Classic-session redirect convention — used by the left-nav Classic
 * links and any other entry point (e.g. the dashboard "View all") that hands off to the legacy app.
 *
 * @param path The Classic root-relative path (including querystring), e.g.
 *   `/Home/DisplayFilingList.aspx?t=1&s=1&go=rejected`.
 */
export const buildClassicUrl = (path: string): string => {
  const base = environment.iframeUrl;
  const separator = base.includes('?') ? '&' : '?';
  return `${base}${separator}returnURL=${encodeURIComponent(path)}`;
};

/**
 * Builds a direct URL to a static Classic File & ServeXpress resource on the environment's legacy
 * host, without the Login redirect. Use only for pages that need no legacy session (e.g. the
 * `agreement.htm` Terms & Conditions page).
 *
 * @param path The Classic root-relative path (including querystring), e.g. `/agreement.htm?v=20200905`.
 */
export const buildClassicStaticUrl = (path: string): string =>
  new URL(path, new URL(environment.iframeUrl).origin).toString();
